module.exports = __webpack_public_path__ + "static/media/image5.ffb11094.png";